/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(8),
  borderRadius: '8px',
  background: 'linear-gradient(180deg, #035260 0%, #123048 100%)',
  position: 'relative',
}));

export const Content = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  position: 'relative',
  zIndex: 10,
}));

export const BgImage = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 0,
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.primary.on,
  fontSize: '32px',
  fontWeight: 400,
  lineHeight: '36px',
}));

export const DescriptionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.primary.on,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const MainBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
}));

export const WidgetsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  flexShrink: 0,
  width: '712px',
  gap: theme.spacing(2),
}));

export const WidgetRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

interface ColorProps {
  bgColor: string;
  textColor: string;
  iconSize?: string;
}

export const Widget = styled(Box, {
  shouldForwardProp: prop => prop !== 'bgColor' && prop !== 'textColor' && prop !== 'iconSize',
})<ColorProps>(({theme, bgColor, textColor, iconSize}) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  borderRadius: '8px',
  background: bgColor,
  backdropFilter: 'blur(4px)',
  userSelect: 'none',

  p: {
    color: textColor,
  },

  '.MuiSvgIcon-root': {
    color: textColor,
    fontSize: iconSize || '20px',
  },
}));

export const WidgetText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'center',
}));

export const BadgeBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'bgColor' && prop !== 'textColor',
})<ColorProps>(({theme, bgColor, textColor}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  '> div': {
    background: bgColor,
    color: textColor,
  },
}));

export const Badge = styled(Box)(({theme}) => ({
  borderRadius: '9px',
  height: '18px',
  padding: theme.spacing(0, 1),
  display: 'flex',
  alignItems: 'center',

  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '14px',
}));

export const Footer = styled(Box)(({theme}) => ({
  width: '100%',
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(4),
}));

export const SettingsImageWrap = styled(Box)(() => ({
  width: '676px',
}));

export const CloseButton = styled(Button)(({theme}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '48px',
  minWidth: 'unset',
  height: '48px',

  '.MuiSvgIcon-root': {
    color: theme.palette.semantic_dark?.surface.onSurface,
    fontSize: '20px',
  },
}));
